import PATH from "constants/path";
import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useHistory } from "react-router-dom";
import { SERVICE } from "constants/global";
import { getUser } from "features/User/userSlice";
import { Notice } from "components";

function ChangePassword() {
  const history = useHistory();
  const dispatch = useDispatch();

  const { user, noticesInit } = useSelector((state) => state.user);

  useEffect(() => {
    if (!user) {
      dispatch(getUser());
    }
  }, []);

  if (!user) return null;

  return (
    <div className="w-80 py-0 py-md-3">
      <Notice noticesInit={noticesInit} />

      <div className="fs-20 fs-sm-18 fw-600 my-3 my-md-4 text-center">
        パスワードの変更
      </div>

      <div className="px-3 px-md-0">
        <table className="table-view id border-radius-0 border-radius-sm-5 my-3 w-100">
          <tbody>
            <tr>
              <td className="fs-14 fw-600 ps-3">パスワード</td>
              <td className="ps-2 ps-md-3 align-middle">*********</td>
            </tr>
          </tbody>
        </table>
      </div>

      <div className="group-btn-update my-4 my-md-5 px-3 px-md-0">
        <div onClick={() => history.push(PATH.SETTING)} className="btn-update">
          戻る
        </div>
        <div
          onClick={() => {
            window.location = `${PATH.COMMON}${PATH.UPDATE_PASSWORD.UPDATE}?service=${SERVICE}&url_back=${window.location.href}`;
          }}
          className="btn-update red-light"
        >
          変更する
        </div>
      </div>
    </div>
  );
}

export default ChangePassword;
